/**
 * Number of applications by five underwriting/ re-underwriting, by place of Residence of Insured Person
 */

import {
	isHongKongResident,
	hasLoadings,
	hasExclusions
} from "@/modules/reports/schemas/utils/"

import get from "lodash.get"

export default payload => {
	const workSheetData = [...header, ...rows(payload)]
	const workSheetColumns = header[2].map(item => {
		return { wpx: 100 }
	})
	const workSheetMerges = [
		{ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } },
		{ s: { r: 1, c: 0 }, e: { r: 3, c: 0 } },
		{ s: { r: 1, c: 1 }, e: { r: 1, c: 8 } },
		{ s: { r: 1, c: 9 }, e: { r: 1, c: 16 } },
		{ s: { r: 2, c: 1 }, e: { r: 2, c: 2 } },
		{ s: { r: 2, c: 3 }, e: { r: 2, c: 4 } },
		{ s: { r: 2, c: 5 }, e: { r: 2, c: 6 } },
		{ s: { r: 2, c: 7 }, e: { r: 2, c: 8 } },
		{ s: { r: 2, c: 9 }, e: { r: 2, c: 10 } },
		{ s: { r: 2, c: 11 }, e: { r: 2, c: 12 } },
		{ s: { r: 2, c: 13 }, e: { r: 2, c: 14 } },
		{ s: { r: 2, c: 15 }, e: { r: 2, c: 16 } }
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}

const header = [
	[
		"Template A2 - Number of accepted/rejected offer of customers by four Underwriting/ Re-underwriting results, by Place of Residence of Insured Person"
	],
	[
		"Place of Residence",
		"Standard Plan",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"Flexi Plan"
	],
	[
		"",
		"Standard Offer",
		"",
		"Offer with Premium Loading only",
		"",
		"Offer with CBE only",
		"",
		"Offer with Premium Loading and CBE",
		"",
		"Standard Offer",
		"",
		"Offer with Premium Loading only",
		"",
		"Offer with CBE only",
		"",
		"Offer with Premium Loading and CBE",
		""
	],
	[
		"",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject"
	]
]

const rows = payload => [
	[
		"Hong Kong",
		countStandardOffer(true, payload, "QUOTING"),
		countStandardOffer(true, payload, "REJECTED"),
		countOfferWithLoadings(true, payload, "QUOTING"),
		countOfferWithLoadings(true, payload, "REJECTED"),
		countOfferWithExclusions(true, payload, "QUOTING"),
		countOfferWithExclusions(true, payload, "REJECTED"),
		countOfferWithLoadingsAndExclusions(true, payload, "QUOTING"),
		countOfferWithLoadingsAndExclusions(true, payload, "REJECTED")
	],
	[
		"Others",
		countStandardOffer(false, payload, "QUOTING"),
		countStandardOffer(false, payload, "REJECTED"),
		countOfferWithLoadings(false, payload, "QUOTING"),
		countOfferWithLoadings(false, payload, "REJECTED"),
		countOfferWithExclusions(false, payload, "QUOTING"),
		countOfferWithExclusions(false, payload, "REJECTED"),
		countOfferWithLoadingsAndExclusions(false, payload, "QUOTING"),
		countOfferWithLoadingsAndExclusions(false, payload, "REJECTED")
	]
]

const countStandardOffer = (isPlaceOfResidence, payload, status) => {
	return payload.filter(policy => {
		let address = get(policy, "insured[0].addresses")
		let resident = isHongKongResident(address)
		let loadings = hasLoadings(policy)
		let exclusions = hasExclusions(policy)

		if (
			policy.status === status &&
			resident === isPlaceOfResidence &&
			loadings === false &&
			exclusions === false
		) {
			return policy
		}
	}).length
}

const countOfferWithLoadings = (isPlaceOfResidence, payload, status) => {
	return payload.filter(policy => {
		let address = get(policy, "insured[0].addresses")
		let resident = isHongKongResident(address)
		let loadings = hasLoadings(policy)
		let exclusions = hasExclusions(policy)
		if (
			policy.status === status &&
			loadings === true &&
			exclusions === false &&
			resident === isPlaceOfResidence
		) {
			return policy
		}
	}).length
}

const countOfferWithExclusions = (isPlaceOfResidence, payload, status) => {
	return payload.filter(policy => {
		let address = get(policy, "insured[0].addresses")
		let resident = isHongKongResident(address)
		let exclusions = hasExclusions(policy)
		let loadings = hasLoadings(policy)
		if (
			policy.status === status &&
			exclusions === true &&
			loadings === false &&
			resident === isPlaceOfResidence
		) {
			return policy
		}
	}).length
}

const countOfferWithLoadingsAndExclusions = (
	isPlaceOfResidence,
	payload,
	status
) => {
	return payload.filter(policy => {
		let address = get(policy, "insured[0].addresses")
		let resident = isHongKongResident(address)
		let loadings = hasLoadings(policy)
		let exclusions = hasExclusions(policy)
		if (
			policy.status === status &&
			loadings &&
			exclusions &&
			resident === isPlaceOfResidence
		) {
			return policy
		}
	}).length
}
